import { ERROR_CODES, SUBSCRIPTION_ERRORS } from '../errorCodes';

export const isSubscriptionError = (errorCode: string) => {
  return Object.keys(SUBSCRIPTION_ERRORS).includes(errorCode);
};

export const isAuthError = (code: string) =>
  [ERROR_CODES.UNAUTHORIZED, ERROR_CODES.TOKEN_EXPIRED].includes(code);
